import React from "react";

import TelaGeral from "../../components/TelaGeral";

export const SelecionaPaciente = ({ onRequestClose, isOpen, data, handleIncluiFilaAtendimento, handleValidaFilaAtendimento }) => {
    return (
        <TelaGeral
            isOpen={isOpen}
            // onRequestClose={onRequestClose}
            titulo="Selecione o paciente"
        >
            <div className="paciente-container">
                {data?.map((paciente) => {
                    return (
                        <div className="paciente-item" key={paciente.codpaciente}>
                            <div className="paciente-item-detail">
                                <span className="paciente-item-nome">
                                    {paciente.nome}
                                </span>
                                {
                                    paciente.dataNascimento
                                    ?
                                    <span className="paciente-item-nascimento">
                                        {paciente.dataNascimento}
                                    </span>
                                    : null
                                }
                            </div>

                            <div className="paciente-item-select">
                                <button className="paciente-item-btn-select" onClick={() => handleValidaFilaAtendimento(paciente.codpaciente, false)}>Seleciona</button>
                            </div>
                        </div>
                    )                    
                })}
            </div>
        </TelaGeral>
    );
};